// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__28fy9","label":"Section_label__2vuh2","contentWrap":"Section_contentWrap__1isjE","footer":"Section_footer__37pUX","footerInner":"Section_footerInner__2PkCh"};